module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.2618137b.svg";